// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CartController from "./cart_controller"
application.register("cart", CartController)

import CheckoutController from "./checkout_controller"
application.register("checkout", CheckoutController)

import FaqController from "./faq_controller"
application.register("faq", FaqController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import LoginModalController from "./login_modal_controller"
application.register("login-modal", LoginModalController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import OtpChallengeController from "./otp_challenge_controller"
application.register("otp-challenge", OtpChallengeController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)
